var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-by-step"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"step-item"},[_c('div',{staticClass:"step-marker"},[_c('span',{staticClass:"step-num"},[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('div',{staticClass:"step-body",domProps:{"innerHTML":_vm._s(step)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }